import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Choose your language',
  english: 'English',
  spanish: 'Spanish',
  french: 'French',
  russian: 'Russian',
  chinese: 'Chinese',
  italian: 'Italian',
  japanese: 'Japanese',
  turkish: 'Turkish',
  vietnamese: 'Vietnamese',
  korean: 'Korean',
  portuguese: 'Portuguese',
});
